// src/utils/Loading.jsx
import React from "react";
import { Spinner } from "@heroui/react";

const Loading = ({ size = "lg", variant = "spinner", className = "" }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <Spinner size="lg" variant="spinner" color="warning" />
    </div>
  );
};

export default Loading;
